import { registrationCamsStoreDefaultValue } from '../services/registration-cams/context';
import { createGlobalStore } from './store/utils';

export const cams = createGlobalStore(registrationCamsStoreDefaultValue, 'cams');
